import { useEffect, useContext, useState } from "react";
import { AuthContext } from "../contexts/AuthContextProvider.jsx";
import {
	configureLogout,
	configureRequestOtp,
	configureSetAccessToken,
} from "../services/apiClient.js";
import { showErrorToast } from "../services/toastService.js";
import { OtpModal } from "./modals/OtpModal.jsx"; // Usa il modale corretto
import apiClient from "../services/apiClient"; // Importa il wrapper corretto

const ApiClientConfigurator = () => {
	const [isOtpModalOpen, setOtpModalOpen] = useState(false);
	const [pendingRequest, setPendingRequest] = useState(null);
	const [resolvePending, setResolvePending] = useState(null);
	const [rejectPending, setRejectPending] = useState(null);
	const [session, setSession] = useState(null);

	const { logout, setAccessToken } = useContext(AuthContext);

	useEffect(() => {
		configureLogout(logout);
	}, [logout]);

	useEffect(() => {
		configureSetAccessToken(setAccessToken);
	}, [setAccessToken]);

	useEffect(() => {
		configureRequestOtp((resolve, reject, originalRequest, session) => {
			// Mostra il modale e salva la richiesta pendente
			setPendingRequest(originalRequest);
			setResolvePending(() => resolve);
			setRejectPending(() => reject);
			setSession(session);
			setOtpModalOpen(true);
		});
	}, []);

	const closeModal = () => {
		setOtpModalOpen(false);
		if (rejectPending) {
			rejectPending(new Error("OTP richiesta annullata dall'utente."));
			setRejectPending(null);
			showErrorToast("Verifica OTP annullata.");
		}
	};

	const handleOtpSubmit = (otpCode) => {
		// Non chiudere subito il modale
		const updatedRequest = {
			...pendingRequest,
			data: {
				...JSON.parse(pendingRequest.data || "{}"),
				otp_code: otpCode,
			},
		};

		apiClient[updatedRequest.method.toLowerCase()](
			updatedRequest.url,
			{ ...updatedRequest.data, session },
			{
				headers: updatedRequest.headers,
			}
		)
			.then((response) => {
				resolvePending(response);
				setOtpModalOpen(false); // Chiudi solo se la richiesta ha successo
			})
			.catch((err) => {
				if ((err.response && err.response.status < 400) || err.response.status > 499) {
					showErrorToast(err.message);
					setOtpModalOpen(false); // Chiudi per altri errori
					resolvePending(Promise.reject(err));
				}
			});
	};

	return (
		<OtpModal isOpen={isOtpModalOpen} onRequestClose={closeModal} onSubmit={handleOtpSubmit} />
	);
};

export default ApiClientConfigurator;
